//create react component sample template

import React from 'react';
import { ListBox, Item } from '@adobe/react-spectrum';
import CardComponent from './MessagesCardComponent';
import CardComponentLarge from './MessagesCardComponentLarge';
import ConceptCardComponent from './ConceptCardComponent';

interface TodoListProps {
  listMessageList: any;
  items: any[];
  isLoading: boolean;
  handleListRowLargeClick: (key: any) => void;
  rowsData: any;
  totalMessageListRec: number;
  selectedKeys: any;
  selectedDataRow: any;

  isMobile: boolean;

  messageType: any;
}

const MessageList: React.FC<TodoListProps> = ({ listMessageList, handleListRowLargeClick, rowsData, totalMessageListRec, selectedKeys, isMobile, messageType }) => {
  return (
    <ListBox
      autoFocus
      id="listMessageCardsMobile"
      selectionMode="single"
      onSelectionChange={handleListRowLargeClick}
      defaultSelectedKeys={selectedKeys}
      selectedKeys={selectedKeys}
      aria-label="Message_List_Component_Mobile"
      items={listMessageList.items}
      isLoading={listMessageList.isLoading}
      onLoadMore={totalMessageListRec > rowsData.length ? listMessageList.loadMore : undefined}
      width={'100%'}
      UNSAFE_style={{ padding: '0 0 0 5px' }}
    >
      {(item: any) => <Item key={item.id}>{messageType === 'concept' ? <ConceptCardComponent item={item} /> : isMobile ? <CardComponent item={item} /> : <CardComponentLarge item={item} />}</Item>}
    </ListBox>
  );
};

export default MessageList;
